import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Grid,
  Input,
  Button,
} from "@mui/material";
import kazanimg from "../../../Assets/a_20.png";
import "../../CSS/CrownCss/Kazan123.css";
import { Link } from "react-router-dom";
const kazanData = {
  id: 1,

  isitmaGidis: "80.0(°C)",
  isitmaDonus: "60.0(°C)",
  kapasite: "80.0%",
  calismaZamani: "2570.0 hr",
  gazSayaciAnlik: "2.6m3/h",
  gazSayaciToplam: "20.0m3/h",
  kazanKapasite: "80.0%",
  kazanBasinci: "2.6 bar",
  kazanDonusSicakligi: "60.0(°C)",
  kazanCikisSicakligi: "80.0(°C)",
  p1Calisma: "Start",
  p1Ariza: "Normal",
  p2Calisma: "Stop",
  p2Ariza: "Normal",
  p1Akim: "10.2 A",
  p2Akim: "0.0A",
};

const Kazan1 = () => {
  return (
    <div className="container-kazan1">
      <Link to="/">
        <Button
          style={{
            position: "absolute",
            color: "black",
            top: "12%",
            left: "18%",
            zIndex: 9999999,
            borderRadius: "15px",
            backgroundColor: "#fff",
            border: "3px solid rgba(238, 200, 108, 0.99)",
            fontWeight: 600,
          }}
          className=" movebuttons"
          variant="contained"
        >
          Ana Ekran
        </Button>
      </Link>
      <div className="kazan123top">
        <div>KAZAN - 1</div>
      </div>
      <div className="kazan123-move">
        <Link className="buttons" to="/kazan3">
          Geri
        </Link>
        <Link className="buttons" to="/kazan2">
          İleri
        </Link>
      </div>

      <div className="kazan1-container">
        <div className="kazan1-table">
          <p className="title">Kazan-{kazanData.id} Durumu</p>
          {Object.entries(kazanData).map(
            ([key, value]) =>
              key !== "id" && (
                <div className="row" key={key}>
                  <p>
                    {key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                  </p>
                  <div className={`kazan-${key}`}>{value}</div>
                </div>
              )
          )}
        </div>
        <div className="div-kazan-img">
          <img
            src={kazanimg}
            className="kazan1-img"
            alt={`Kazan ${kazanData.id}`}
          />
        </div>

        <div className="kazan1-table">
          <p className="title">Kazan-{kazanData.id} Durumu</p>
          {Object.entries(kazanData).map(
            ([key, value]) =>
              key !== "id" && (
                <div className="row" key={key}>
                  <p>
                    {key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                  </p>
                  <div className={`kazan-${key}`}>{value}</div>
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default Kazan1;
